module.exports = __webpack_public_path__ + "static/media/1.84d8e474.svg";